e.S.available_subscriptions = {
	api : config.api + 'subscriptions/',

	content : {},
	template : {},
	current_subs : {},
	wrap : {},

	by_site        : {},
	site_select    : {},
	type_select    : {},
	types_template : {},
	filter_by : {},

	by_name  : {},
	search_field : {},

	init : function(){
		_.bindAll( this, '_update_category_select' );

		var $avail = this.wrap = $( '#available-subscriptions' );
		if( $avail.length ){
			this.template = Handlebars.compile( $( '#subscription-list-item' ).html() );
			this.current_subs = $( '#current-subscriptions' ).find( '#the-list' );
			this.types_template = Handlebars.compile( $( '#sub-category-options' ).html() );
			this.by_site = $( '#by-site' );
			this.site_select = this.by_site.find( '.site-select' );
			this.type_select = this.by_site.find( '.sub-type' );
			this.filter_by = $( '.filter-by' );
			this.by_name = $( '#by-name' );
			this.search_field = $avail.find( '#search' );


			$avail.on( 'click', '.navigation a', this._update_items_from_pagination );
			$avail.on( 'click', '.dashboard-subscribe', this._subscribe );
			$avail.on( 'click', '.subscription-meta', this._store_checkbox_meta );
			//when viewing on FE /subscriptions
			$avail.on( 'click', '.edspire-subscribe, .edspire-un-subscribe', this._update_subscribe_count );

			this.site_select.on( 'change', this._update_category_select );
			this.type_select.on( 'change', function(){
				e.S.available_subscriptions._update_items( e.S.available_subscriptions.by_site );
			} );

			this.search_field.on( 'keyup', _.debounce( this._update_items_all_sections, 400 ) );
			this.filter_by.on( 'change', function(){
				var $parent_id = $( this ).data( 'rel' );
				e.S.available_subscriptions._update_items( $( '#' + $parent_id ) );
			});
		}
	},


	_update_subscribe_count : function(){
		var button = $( this );
		var placeholder = button.parents( 'tr' ).find( '.count-placeholder' );
		if( placeholder.length ){
			var $count = placeholder.data( 'count' );
			if( !button.hasClass( 'edspire-subscribe' ) ){
				$count--;
			} else {
				$count++;
			}
			placeholder
				.text( $count )
				.data( 'count', $count );
		}
	},

	/**
	 * Saves the state of a checkbox via subscription
	 * meta
	 *
	 * @private
	 */
	_store_checkbox_meta : function(){
		var toggle = $( this );
		toggle.data( 'method', 'update_meta' );
		if( !_.isUndefined( toggle.data( 'reverse' ) ) ){
			toggle.data( 'checked', toggle.prop( 'checked' ) ? 0 : 1 );
		} else {

			toggle.data( 'checked', toggle.prop( 'checked' ) ? 1 : 0 );
		}


		$.post( e.S.available_subscriptions.api, toggle.data(), function( $data ){
			// @ifdef DEBUG
			console.info( $data );
			// @endif
		} );

	},


	_subscribe : function(){
		self = e.S.available_subscriptions;
		var $item = $( this );
		$item.data( 'method', 'subscribe_all_formats' );
		$.post( e.S.button.api, $item.data(), function( $data ){
			$item.parents( 'tr' ).remove();
			// @ifdef DEBUG
			console.info( $data );
			// @endif
			self.current_subs.append( self.template( $data.data ) );
		} );
	},


	/**
	 * Update the category options when a site is selected
	 * Then update the available subscriptions table
	 *
	 *
	 * @private
	 */
	_update_category_select : function(){
		var $site = this.site_select.find( ':selected' ).text();
		this.type_select.html( this.types_template( { site : $site } ) );

		this._update_items( this.by_site );
	},

	/**
	 * Updates all 3 lists of items
	 * Used for things like search
	 *
	 *
	 * @private
	 */
	_update_items_all_sections : function(){
		var self = e.S.available_subscriptions;
		var $wrap = self.wrap.find( '.subscriptions-container' );

		self._request_items( $wrap, false, 1 );
	},

	/**
	 * Update the subscription items from a select or a search.
	 * Not the same as the paginate links because they have a
	 * different element hierarchy which required a different method
	 *
	 * If you change this method be sure to change the other one
	 *
	 * @see this._update_items_from_pagination
	 *
	 * @param {jQuery} $parent
	 * @private
	 */
	_update_items : function( $parent ){
		var $wrap = $parent.find( '.subscriptions-container' );

		e.S.available_subscriptions._request_items( $wrap, $parent, 1 );
	},

	/**
	 * Update the subscription items when a paginate link is click.
	 * Not the same as the selects or searches because they have a
	 * different element hierarchy which required a different method
	 *
	 * If you change this method be sure to change the other one
	 *
	 * @see this._update_items_from_pagination
	 *
	 * @private
	 */
	_update_items_from_pagination : function(){
		var self = e.S.available_subscriptions;
		var el = $( this );
		var $wrap = el.parents( '.subscriptions-container' );
		$section = $wrap.parent();

		self._request_items( $wrap, $section, el.data( 'page' ) );

	},

	/**
	 * Retrieve items via ajax and update the available subscriptions
	 * table with the result
	 *
	 * @param {jQuery} $wrap
	 * @param {(jQuery|bool)} $section
	 * @param {int}    $page
	 * @private
	 */
	_request_items : function( $wrap, $section, $page ){
		var $data = {
			page : $page,
			method : 'get_available_subscriptions',
			sort_by : $wrap.data( 'sort_by' ),
			search : this.search_field.val(),
			is_admin : config.is_admin,
			is_subscriptions_page : config.is_subscriptions_page
		};

		if( $section ){
			if( $section.attr( 'id' ) == 'by-site' ){
				$data.site = this.site_select.find( ':selected' ).val();
				$data.type = this.type_select.find( ':selected' ).val();
			} else {
				if( $section.find( '.filter-by' ).val() ){
					$data.type = $section.find( '.filter-by' ).val();
				}
			}
		}


		$.post( e.S.available_subscriptions.api, $data, function( out ){
			$wrap.html( out );
		} );
	}

};